import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { PaginatedResponse } from '@/types/api';
import type { Progression, ProgressionCreateResponse } from '@/types/respondent';

/**
 * Retrieve the list of a respondent's non-deleted and non-ignored progressions from the API.
 *
 * @param respondentId - The ID of the respondent for whom to fetch progressions.
 * @returns A Promise resolving to the Axios response containing the paginated list of progressions.
 */
export async function progressionsGetQuery(
  respondentId: string,
): Promise<AxiosResponse<PaginatedResponse<Progression>>> {
  const requestOptions = {
    method: 'GET',
    url: `/progressions/`,
    params: {
      deletedAtIsNull: true,
      ignoredAtIsNull: true,
      respondent: respondentId
    }
  };
  return api(requestOptions);
}

/**
 * Post a list of progressions to the database.
 *
 * @param progressionsToPost - The list of progressions to save to the API.
 * @returns A Promise resolving to the Axios response containing the paginated list of saved progressions.
 */
export async function progressionsPostQuery(
  progressionsToPost: Progression[]
): Promise<AxiosResponse<ProgressionCreateResponse>> {
  const requestOptions = {
    method: 'POST',
    url: `/progressions/`,
    data: progressionsToPost,
  };
  return api(requestOptions);
}